module.exports = __webpack_public_path__ + "img/04-3-4卓越运维.32e66365.svg";